<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Recurring Payments"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create recurring payments."
      @on-submit="createRecurringPaymentsImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Recurring Payments Template.xlsx"
              :file-provider="$importsAPI.getRecurringPaymentsTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'RecurringPaymentsImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'recurring-payments-imports-add-modal',
    };
  },
  methods: {
    createRecurringPaymentsImport(data, handleCreate) {
      handleCreate(this.$importsAPI.recurringPaymentsCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
